import { create } from "zustand";

export type RosterCreateUiMode =
  | "none"
  | "edit"
  | "deadline"
  | "wanted"
  | "wantedSelector"
  | "manpower"
  | "offRequest"
  | "emergency";

type RosterCreateUiState = {
  mode: RosterCreateUiMode;
  setMode: (next: RosterCreateUiMode) => void;
  resetMode: () => void;
};

export const useRosterCreateUiStore = create<RosterCreateUiState>((set) => ({
  mode: "none",
  setMode: (next) => set({ mode: next }),
  resetMode: () => set({ mode: "none" }),
}));
